import React from 'react';
import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';
import { Label, Message } from '@naf/input';
import { normalizeInput } from '@utils/normalizeInput';
import S from '../styles';

export const LastName = <T extends FieldValues>({
  name,
  control,
  defaultValue,
  errorMessage,
  isDisabled,
}: UseControllerProps<T> & { errorMessage?: string; isDisabled?: boolean }) => (
  <S.LastName>
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { value, onChange } }) => (
        <S.FieldWrapper>
          <Label>Etternavn</Label>
          <S.ResponsiveTextField
            error={!!errorMessage}
            onChange={(e) => onChange(normalizeInput(e))}
            value={value}
            autoComplete="family-name"
            disabled={isDisabled}
          />
          {!!errorMessage && <Message error>{errorMessage}</Message>}
        </S.FieldWrapper>
      )}
    />
  </S.LastName>
);
